import {AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output,} from '@angular/core';
import {CommissionBottomsheetComponent} from '../../overlays/commission-bottomsheet/commission.bottomsheet.component';
import {FileResponse} from '../../../../models/file.response';
import {saveAs} from 'file-saver';
import {CreateDeliveryNoteComponent} from '../../overlays/create-delivery-note/create.delivery.note.component';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {SuppliersService} from '../../../../services/suppliers.service';
import {MatDialog} from '@angular/material/dialog';
import {ChangedOverlayComponent} from '../../overlays/changed-overlay/changed.overlay.component';
import {APP_GUIDS, AppGuids} from '../../../../app.guids';
import {Observable} from 'rxjs';
import {UploadMeasurementProtocolComponent} from "./upload-measurement-protocol/upload-measurement-protocol.component";
import {TranslateService} from "@ngx-translate/core";
import {CoreService, DocumentService, Param, ProleisObject, Types} from "@proleis/proleis-rest-client";
import {CurrentViewService, NotificationService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-position-tl-card',
  templateUrl: 'position.card.tl.component.html',
  styleUrls: ['position.card.tl.component.scss'],
})
export class PositionCardTlComponent implements OnInit, AfterViewInit {
  @Input()
  pos: ProleisObject;

  @Input()
  pbo: ProleisObject;
  changed: boolean;

  resolvedIcons: Observable<Map<string, string>>;

  @Output()
  checkChangedEvent = new EventEmitter<boolean>();

  constructor(
    private bottomSheet: MatBottomSheet,
    private currentViewService: CurrentViewService,
    public suppliersService: SuppliersService,
    private coreService: CoreService,
    private notificationService: NotificationService,
    private documentsService: DocumentService,
    private dialog: MatDialog,
    private translationService: TranslateService,
    @Inject(APP_GUIDS) private guids: AppGuids,
  ) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.changed = this.suppliersService.hasOrderChanged(this.pos);
  }

  editCommissionPart(pseId: string) {
    this.bottomSheet
      .open(CommissionBottomsheetComponent, {data: pseId})
      .afterDismissed()
      .subscribe((result) => {
      });
  }

  isPreliminary(pos: ProleisObject): boolean {
    return pos.ISPRELIMINARY_INDEX_AI;
  }

  isExternal(): boolean {
    return this.pbo.CHANNELGUID !== this.guids.GUID_CHANNEL_INTERNAL;
  }

  isBm(): boolean {
    return this.pos.PSETYPGUID === this.guids.GUID_PSETYP_BM;
  }

  editCommissionOrder(pboId: string) {
    this.bottomSheet
      .open(CommissionBottomsheetComponent, {data: pboId})
      .afterDismissed()
      .subscribe((result) => {
      });
  }

  printLabel(pos: ProleisObject) {
    const params: Param[] = [
      {name: 'STARTOBJECT_ID', type: Types.DOUBLE, value: pos.OBJECT_ID},
    ];

    this.currentViewService.setLoading(true);
    this.suppliersService.getExportLabel().subscribe((docExport) => {
      this.coreService
        .executeAction<ProleisObject>(
          docExport.OBJECT_ID,
          '§6d652cfe-2aec-11b2-80e0-1df7d76ee300',
          params,
        )
        .subscribe((obj) => {
          this.documentsService
            .getDocumentFile(obj.HANDLER_CHECKIN_RESULTS)
            .subscribe((response) => {
              const fileResponse: FileResponse =
                FileResponse.parseResponse(response);
              saveAs(fileResponse.content, fileResponse.fileName);
              this.currentViewService.setLoading(false);
            });
        });
    });
  }

  downloadDeliveryNote(deliveryNote: ProleisObject) {
    return this.documentsService
      .getDocumentFile(deliveryNote.DE_DOC_ID)
      .subscribe((response) => {
        const fileResponse: FileResponse = FileResponse.parseResponse(response);
        saveAs(fileResponse.content, fileResponse.fileName);
        this.currentViewService.setLoading(false);
      });
  }

  createDeliveryNote(pos: ProleisObject) {
    this.bottomSheet
      .open(CreateDeliveryNoteComponent)
      .afterDismissed()
      .subscribe((bottomSheetData) => {
        if (bottomSheetData) {
          const params: Param[] = [
            {
              name: 'STEP_INFO_TEXT',
              value: bottomSheetData.deliveryNr,
              type: Types.TEXT,
            },
            {
              name: 'STEP_INFO_TEXT_COUNT',
              value: bottomSheetData.count,
              type: Types.DOUBLE,
            },
            {
              name: 'STEP_INFO_MODE',
              value: bottomSheetData.replacement,
              type: Types.BOOL,
            },
          ];
          this.currentViewService.setLoading(true);
          // 32247448-2c49-11b2-80ce-5b47e4bd1ab4 = SCRIPT_PSE_CREATE_DELIVERYNOTE_EXTERN
          this.coreService
            .executeAction<any>(
              pos.OBJECT_ID,
              '§32247448-2c49-11b2-80ce-5b47e4bd1ab4',
              params,
            )
            .subscribe((result) => {
              this.suppliersService
                .getDeliveryNote(result.value, 'DE_DOC_ID=DE_DOC_ID')
                .subscribe((note) => {
                  this.downloadDeliveryNote(note);
                  this.currentViewService.setLoading(false);
                  this.notificationService.showNotification(
                    'Lieferschein angelegt',
                  );
                });
            });
        }
      });
  }

  openChangedDialog() {
    this.dialog
      .open(ChangedOverlayComponent, {
        data: {
          docName: this.pos.DWS_CHANGE_DOCUNAME,
          docId: this.pos.DWS_CHANGE_DOCU_ID,
          posId: this.pos.OBJECT_ID,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        this.checkChangedEvent.emit(true);
      });
  }

  uploadMeasurementProtocol() {
    this.dialog.open(UploadMeasurementProtocolComponent).afterClosed().subscribe((result: FileList) => {
      if (!result) {
        return;
      }
      const formData: FormData = new FormData();
      formData.set('file', result.item(0), result.item(0).name);
      this.coreService
        .executeActionFormData(
          this.pos.OBJECT_ID,
          '§' + this.guids.GUID_UPLOAD_MESSPROTOKOLL_ACTION,
          formData,
          '1474',
        )
        .subscribe((result) => {
          this.notificationService.showNotification(
            this.translationService.instant(
              'orders.positions.tl.uploadSuccess',
            ),
          );
          this.checkChangedEvent.next(true);
        });
    })
  }
}
